import { ArticleParagraph1 } from '@cian/ui-kit/typography';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';
import { NumberInputWithButtons } from '../../../../packages/NumberInputWithButtons';
import { EFiltersMobileTestId } from '../../types';

interface IGuestsCountInputProps {
  className?: string;
  value: number;
  onChange: (value: number) => void;
  min: number;
  max: number;
}

export const GuestsCountInput: React.FC<IGuestsCountInputProps> = ({ className, value, onChange, min, max }) => {
  return (
    <div className={classNames(styles['input-row'], className)}>
      <div className={styles['label']}>
        <ArticleParagraph1>Взрослые и дети</ArticleParagraph1>
      </div>
      <NumberInputWithButtons
        value={value}
        onChange={onChange}
        min={min}
        max={max}
        minusTestId={EFiltersMobileTestId.GuestsFilterMinus}
        plusTestId={EFiltersMobileTestId.GuestsFilterPlus}
      />
    </div>
  );
};
